export default "__VITE_ASSET__BvF64tyo__"